module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.fc2b506.ttf";